export default __webpack_public_path__ + "static/media/close.d066b5a0.svg";